import React, { useEffect, useState, useRef } from "react";
import SensorStyle from "./SensorStyle.module.css";
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import ko from "date-fns/locale/ko"
import moment from 'moment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faDownload } from "@fortawesome/free-solid-svg-icons";
import { responseMsg } from "../common/ResponseMsg";
import CusFullCalendar from "../holiday/CusFullCalendar";
import { OverlayPanel } from 'primereact/overlaypanel';
import Flex from "../../shared/components/Flex";
import Card from "../../shared/components/Card";
import Padding from "../../shared/components/Padding";
import Pill from "../../shared/components/Pill";
import IcoMapPin from "../../assets/img/IcoMapPin";
import Text from "../../shared/components/Text";
import useDevice from "../../shared/hooks/useDevice";
import SensorStatusBoardItemStyle from "../main/components/css/SensorStatusBoardItem.module.css";
import Button from "../../shared/components/Button";
import ManageButton from "../../shared/components/ManageButton";
import IcoDownload from "../../assets/img/img_download.png";
import Label from "../../shared/components/Label";
import Input from "../../shared/components/Input";
import PrettySelect from "../../shared/components/PrettySelect";
import ToggleStyle from "./ToggleSwitch.module.css";

function DetailSearchWrap(props) {
    const [render, setrRender] = useState(false);
    const [selectedInterval, setSelectedInterval] = useState("12hour");
    const [selectedRange, setSelectedRange] = useState("0");
    const [chartXTicks, setChartXTicks] = useState(1);
    // 현재 보여주는 컴포넌트 상태값
    const [selectedVisual, setSelectedVisual] = useState("table")
    const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DDTHH:mm"));
    const [endDate, setEndDate] = useState(moment().subtract(12, "hours").format("YYYY.MM.DD HH:mm:ss"));
    const [holidayList, setHolidayList] = useState([]);
    const device = useDevice();
    const isMobile = device !== 'desktop';

    const holidayOp = useRef(null);

    const handleClick = () => {
        props.comeback();
        props.setSearchProps({});
    }

    const handleSearch = () => {
        setrRender(!render);
    }

    const excelDownload = () => {
        // excelHeaders가 있으면 사용 (DetailComponent용), 없으면 기존 로직 사용 (DetailComponentNew용)
        let headers;
        if (props.excelHeaders) {
            headers = props.excelHeaders;
        } else {
            headers = props.detailGrid.filter(ele => ele.field && ele.headerName && !ele.notExcel).map(ele => {
                return {key: ele.field, text: ele.headerName};
            });
        }

        fetch(`/api/data/measurement/excel`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
              },
            body: JSON.stringify({
                imei:props.selectedRow?.imei,
                startDate:moment(startDate).format("YYYY.MM.DD HH:mm:ss"),
                endDate:endDate,
                headers: headers
            }),
        })
        .then((res) => res.blob())
        .then((blob) => {
            const href = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute(
                'download', 
                `${props.selectedRow?.manageCd}_${moment(startDate).format("YYYY_MM_DD HH_mm")}~${moment(endDate).format("YYYY_MM_DD_ HH_mm_")}.xlsx`
                );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
    }

    useEffect(() => {
        props.setSearchProps({
            interval:selectedInterval,
            range:selectedRange,
            startDate:startDate, 
            endDate:endDate,
            chartXTicks:chartXTicks
        });
    },[render])

    useEffect(() => {
        const id = props.selectedRow?.region.id

        fetch(`/api/holiday?region=${id}`, {
            method : 'get',
        })
            .then((res) => res.json())
            .then(json => {
                setHolidayList(json.data);
            })
    },[])

    return(
        <>
            <Flex key={props.selectedRow?.imei} noWrap={true} gap={10} flexDirection={isMobile ? "column" : "row"}>
                <Flex alignItems="center" noWrap={true} gap={16}>
                    <Card style={{boxShadow: "0 0 6px 0 #3E63ED2E", borderRadius: "8px"}}>
                        <Padding 
                            paddingY={8}
                            paddingX={12}
                        >
                            <Flex justifyContent="space-between" alignItems="center">
                                <Pill padding={0} style={{ border: "none"}} backgroundColor="transparent" icon={<Flex justifyContent="center" alignItems="center" className={SensorStatusBoardItemStyle["sensor-icon"]}><img src={"/images/ico_star.svg"} alt=""/></Flex>} width={"fit-content"} text={<Text color={"rgba(62, 99, 237, 1)"} weight={"semibold"} size={16}>{props.selectedRow?.manageCd}</Text>}/>
                            </Flex>
                        </Padding>
                    </Card>
                    <Flex flexDirection="row" gap={8} style={{color: "rgba(112, 112, 112, 1)"}}>
                        <IcoMapPin/>
                        <Text
                            weight={"medium"}
                        >
                             {props.selectedRow?.address}
                        </Text>
                    </Flex>
                </Flex>
                <Flex justifyContent="flex-end" alignItems="center" gap={10} fullWidth flexDirection={isMobile ? "column-reverse" : "row"}>
                    <Flex gap={10} fullWidth={isMobile}>
                        <Button
                            fullWidth={isMobile}
                            width={100}
                            height={isMobile ? "41px" : "34px"}
                            borderRadius={8}
                            variant="white"
                            icon={<img src="images/ico_back.png" alt=""></img>}
                            onClick={handleClick}
                        >
                            <Text variant="span" size={14} weight="semibold" color="black">뒤로가기</Text>
                        </Button>
                        <ManageButton 
                            fullWidth={isMobile}
                            onClick={handleSearch} 
                            btnType='search'
                        />
                    {!props.showChart && (
                        <Button
                            fullWidth={isMobile}
                            height={isMobile ? "41px" : "34px"}
                            width={131}
                            borderRadius={8}
                            backgroundColor="rgba(37, 181, 117, 1)"
                            onClick={excelDownload}
                            icon={<img src={IcoDownload} alt=""/>}
                        >
                            <Text variant="span" size={14} weight="semibold" color="white">
                                {isMobile ? "Excel" : "Excel 다운로드"}
                            </Text>
                        </Button>
                    )}
                    
                    {/* <button className="btn_holiday" onClick={(e) => holidayOp.current.toggle(e)}>달력</button> */}
                    </Flex>
                </Flex>
            </Flex>
            <Card>
                <Padding>
                    <Flex flexDirection={isMobile ? "column" : "row-reverse"} alignItems={isMobile ? "start" : "center"} noWrap={false} gap={12} justifyContent="start">
                        <Flex noWrap={false} flexDirection={isMobile ? "column" : "row"} gap={12} fullWidth={isMobile} style={{userSelect: "none"}}>
                            <Label title="기준일" style={{width: "8ch", cursor: "text", userSelect: "none"}}>기준일</Label>
                            <Input name="installDt" 
                                type="datetime-local"
                                value={startDate}
                                onChange={({target}) => {
                                    setStartDate(target.value)
                                }}/>
                            <Flex gap={5} noWrap={false} flexDirection={isMobile ? "column" : "row"} >
                                <Flex gap={5} noWrap data-select="">
                                    <PrettySelect
                                        textAlign={"center"}
                                        name="dateInterval"
                                        value="12hour"
                                        text={"12시간"}
                                        width={100}
                                        fullWidth={isMobile}
                                        checked={selectedInterval === "12hour"}
                                        onChange={() => {
                                            setSelectedInterval("12hour");
                                            setSelectedRange("0");
                                            setChartXTicks(1);
                                            setEndDate(moment(startDate).subtract(12, "hours").format("YYYY.MM.DD HH:mm:ss"));
                                            setrRender(!render)
                                        }}
                                    />
                                    <PrettySelect
                                        textAlign={"center"}
                                        name="dateInterval"
                                        value="24hour"
                                        text={"24시간"}
                                        width={100}
                                        fullWidth={isMobile}
                                        checked={selectedInterval === "24hour"}
                                        onChange={() => {
                                            setSelectedInterval("24hour");
                                            setSelectedRange("0");
                                            setChartXTicks(2);
                                            setEndDate(moment(startDate).subtract(24, "hours").format("YYYY.MM.DD HH:mm:ss"));
                                            setrRender(!render)
                                        }}
                                    />
                                </Flex>
                                <Flex gap={5} noWrap>
                                    <PrettySelect
                                        textAlign={"center"}
                                        name="dateInterval"
                                        value="1week"
                                        text={"1주일"}
                                        width={100}
                                        fullWidth={isMobile}
                                        checked={selectedInterval === "1week"}
                                        onChange={() => {
                                            setSelectedInterval("1week");
                                            setSelectedRange("1");
                                            setChartXTicks(12);
                                            setEndDate(moment(startDate).subtract(1, "weeks").format("YYYY.MM.DD HH:mm:ss"));
                                            setrRender(!render)
                                        }}
                                    />
                                    <PrettySelect
                                        textAlign={"center"}
                                        name="dateInterval"
                                        value="1month"
                                        text={"1개월"}
                                        width={100}
                                        fullWidth={isMobile}
                                        checked={selectedInterval === "1month"}
                                        onChange={() => {
                                            setSelectedInterval("1month");
                                            setSelectedRange("6");
                                            setChartXTicks(12);
                                            setEndDate(moment(startDate).subtract(1, "months").format("YYYY.MM.DD HH:mm:ss"));
                                            setrRender(!render)
                                        }}
                                    />
                                    <PrettySelect
                                        textAlign={"center"}
                                        name="dateInterval"
                                        value="3month"
                                        text={"3개월"}
                                        width={100}
                                        fullWidth={isMobile}
                                        checked={selectedInterval === "3month"}
                                        onChange={() => {
                                            setSelectedInterval("3month");
                                            setSelectedRange("6");
                                            setChartXTicks(12);
                                            setEndDate(moment(startDate).subtract(3, "months").format("YYYY.MM.DD HH:mm:ss"));
                                            setrRender(!render)
                                        }}
                                    />
                                </Flex>
                            </Flex>
                        </Flex>
                        <Flex flexDirection={isMobile ? "column" : "row"} alignItems={isMobile ? "start" : "flex-end"} gap={12} noWrap={false} fullWidth={isMobile}>
                            <Flex noWrap={false} flexDirection={isMobile ? "column" : "row"} gap={12} fullWidth={isMobile}>
                                <div className={ToggleStyle.toggleContainer} style={isMobile ? { maxWidth: '100%' } : {}}>
                                    <div className={`${ToggleStyle.focusBox} ${selectedVisual === "chart" ? ToggleStyle.right : ""}`} />
                                    <button 
                                        className={`${ToggleStyle.toggleOption} ${selectedVisual === "table" ? ToggleStyle.active : ""}`}
                                        onClick={() => {
                                            setSelectedVisual("table");
                                            props.setShowChart(false);
                                        }}
                                    >
                                        <span className={ToggleStyle.icon}>
                                            <img src="/images/img_rawData.png" alt=""/>
                                        </span>
                                        Raw Data
                                    </button>
                                    <button 
                                        className={`${ToggleStyle.toggleOption} ${selectedVisual === "chart" ? ToggleStyle.active : ""}`}
                                        onClick={() => {
                                            setSelectedVisual("chart");
                                            props.setShowChart(true);
                                        }}
                                    >
                                        <span className={ToggleStyle.icon}>
                                            <img src="/images/img_chart.png" alt=""/>
                                        </span>
                                        Graph
                                    </button>
                                </div>
                            </Flex>
                        </Flex>
                    </Flex>
                </Padding>
            </Card>
        </>
    )
}

export default DetailSearchWrap;
